const id = "BeCORVCUXsNInJVskrjN";
const chars = textToChars(id);

function applySaltToChar(code: number): number {
	return chars.reduce((a, b) => a ^ b, code);
}

function byteHex(n: number): string {
	return ("0" + Number(n)
		.toString(16)).slice(-2);
}

function textToChars(text: string): number[] {
	return text.split("")
		.map((c) => c.charCodeAt(0));
}

/** cipher given text */
export function cipher(text: string): string {
	return textToChars(text)
		.map(applySaltToChar)
		.map(byteHex)
		.join("");
}

/** decipher ciphered text */
export function decipher(text: string): string {
	return text.match(/.{1,2}/g)
		.map((hex) => parseInt(hex, 16))
		.map(applySaltToChar)
		.map((charCode) => String.fromCharCode(charCode))
		.join("");
}
